import { render } from "./CapacityDropdown.vue?vue&type=template&id=10d12584&scoped=true&ts=true"
import script from "./CapacityDropdown.vue?vue&type=script&lang=ts"
export * from "./CapacityDropdown.vue?vue&type=script&lang=ts"

import "./CapacityDropdown.vue?vue&type=style&index=0&id=10d12584&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d12584"]])

export default __exports__